module.exports = __webpack_public_path__ + "img/group_2.7baf4b55.png";